import { render, staticRenderFns } from "./ChatTopicSectionV2026.vue?vue&type=template&id=6979807e&scoped=true"
import script from "./ChatTopicSectionV2026.vue?vue&type=script&lang=js"
export * from "./ChatTopicSectionV2026.vue?vue&type=script&lang=js"
import style0 from "./ChatTopicSectionV2026.vue?vue&type=style&index=0&id=6979807e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6979807e",
  null
  
)

export default component.exports